<template>
  <div>
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>

    <div
      class="product-image-div image container is-128x128"
      style="border: 1px grey solid; background-color: white;"
      @click="$refs.productImage.click()"
    >
      <p v-show="!filename" class="has-text-centered">
        {{ $t("productCreation.add") }}
        <br />
        {{ $t("productCreation.image") }} .png
        <br />
        128x128px
      </p>

      <img v-show="filename" id="product-image" />

      <input
        id="product-main-image"
        type="file"
        ref="productImage"
        style="display: none"
        accept="image/png"
        @change="handleFileUpload"
      />
    </div>

    <b-field
      :label="$t('productCreation.barcode')"
      label-position="on-border"
      style="max-width: 400px; margin: auto; margin-top: 3rem;"
    >
      <b-input v-model="barcode"></b-input>
    </b-field>

    <b-field
      :label="$t('productCreation.name')"
      label-position="on-border"
      style="max-width: 400px; margin: auto; margin-top: 1rem;"
    >
      <b-input v-model="name"></b-input>
    </b-field>

    <div v-if="companyInfo.isCacauShowHeadquarter">
      <b-field
        :label="$t('productCreation.nameEn')"
        label-position="on-border"
        style="max-width: 400px; margin: auto; margin-top: 1rem;"
      >
        <b-input v-model="nameEn"></b-input>
      </b-field>

      <b-field
        :label="$t('productCreation.nameEs')"
        label-position="on-border"
        style="max-width: 400px; margin: auto; margin-top: 1rem;"
      >
        <b-input v-model="nameEs"></b-input>
      </b-field>

      <b-field
        :label="$t('productCreation.description')"
        label-position="on-border"
        style="max-width: 400px; margin: auto; margin-top: 1rem;"
      >
        <b-input v-model="description" type="textarea"></b-input>
      </b-field>

      <b-field
        :label="$t('productCreation.descriptionEn')"
        label-position="on-border"
        style="max-width: 400px; margin: auto; margin-top: 1rem;"
      >
        <b-input v-model="descriptionEn" type="textarea"></b-input>
      </b-field>

      <b-field
        :label="$t('productCreation.descriptionEs')"
        label-position="on-border"
        style="max-width: 400px; margin: auto; margin-top: 1rem;"
      >
        <b-input v-model="descriptionEs" type="textarea"></b-input>
      </b-field>
    </div>

    <b-field
      :label="$t('productCreation.brand')"
      label-position="on-border"
      style="max-width: 400px; margin: auto; margin-top: 1rem;"
    >
      <b-input v-model="brand"></b-input>
    </b-field>

    <b-field
      :label="$t('productCreation.isAlcoholic')"
      label-position="on-border"
      style="max-width: 400px; margin: auto; margin-top: 1rem;"
    >
      <b-field label-position="on-border">
        <b-field style="padding-top: 1rem">
          <b-radio v-model="isAlcoholic" name="product.a" :native-value="false">
            {{ $t("common.no") }}
          </b-radio>

          <b-radio v-model="isAlcoholic" name="product.a" :native-value="true">
            {{ $t("common.yes") }}
          </b-radio>
        </b-field>
      </b-field>
    </b-field>

    <div class="has-text-centered">
      <button
        class="button"
        :style="{
          backgroundColor: $primaryColor,
          color: $primaryColorContrast
        }"
        style="margin-top: 1rem;"
        @click="createProduct"
      >
        {{ $t("productCreation.create") }}
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false,
      file: null,
      filename: "",
      barcode: "",
      name: "",
      nameEn: "",
      nameEs: "",
      description: "",
      descriptionEn: "",
      descriptionEs: "",
      brand: "",
      isAlcoholic: false
    };
  },

  methods: {
    handleFileUpload() {
      if (!this.$refs.productImage.files[0]) return;

      this.filename = this.$refs.productImage.files[0].name;
      this.file = this.$refs.productImage.files[0];

      if (FileReader) {
        var fr = new FileReader();
        fr.onload = function() {
          document.getElementById("product-image").src = fr.result;
        };
        fr.readAsDataURL(this.file);
      }
    },

    createProduct() {
      const formData = new FormData();

      if (this.file && this.file.size > 100000) {
        this.alertError({ message: "FILE_IS_TOO_LARGE_100" });
        return;
      }

      formData.append("file", this.file);
      formData.append("barcode", this.barcode);
      formData.append("name", this.name);
      formData.append("nameEn", this.nameEn);
      formData.append("nameEs", this.nameEs);
      formData.append("description", this.description);
      formData.append("descriptionEn", this.descriptionEn);
      formData.append("descriptionEs", this.descriptionEs);
      formData.append("brand", this.brand);
      formData.append("isAlcoholic", this.isAlcoholic);

      this.isLoading = true;
      this.$store
        .dispatch("createProduct", formData)
        .then(res => {
          if (res.data.result === "error") {
            this.alertError(res.data);
          } else {
            this.$buefy.toast.open({
              duration: 3000,
              message: this.$t("productCreation.productCreated"),
              position: "is-bottom",
              type: "is-success"
            });
            this.barcode = "";
            this.name = "";
            this.nameEn = "";
            this.nameEs = "";
            this.description = "";
            this.descriptionEn = "";
            this.descriptionEs = "";
            this.brand = "";
            this.isAlcoholic = false;
            this.file = null;
            this.filename = "";
            document.getElementById("product-image").src = "";
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["companyInfo"])
  }
};
</script>

<style scoped>
.product-image-div {
  height: 128px;
  width: 128px;
  margin-top: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
}

.product-image-div:hover {
  opacity: 0.5;
  cursor: pointer;
}
#product-image {
  height: 128px;
  width: 128px;
  object-fit: contain;
}
</style>
